export const UpcomingDemoTableColumns = [
    {
        field: 'Number',
        headerName: 'Number',
        type: 'text',
    },
    {
        field: 'Name',
        headerName: 'Name',
        type: 'text',
        width: 180,
    },
    {
        field: 'Demo Start',
        headerName: 'Start',
        type: 'date',
    },
];

export const UpcomingModSetTableColumns = [
    {
        field: 'Number',
        headerName: 'Number',
        type: 'text',
    },
    {
        field: 'Name',
        headerName: 'Name',
        type: 'text',
        width: 180,
    },
    {
        field: 'Mod Set Start',
        headerName: 'Start',
        type: 'date',
    },
];

export const UpcomingHERSRaterTableColumns = [
    {
        field: 'Number',
        headerName: 'Number',
        type: 'text',
    },
    {
        field: 'Name',
        headerName: 'Name',
        type: 'text',
        width: 180,
    },
    {
        field: 'HERS Rater',
        headerName: 'Start',
        type: 'date',
    },
];

export const UpcomingStagingTableColumns = [
    {
        field: 'Number',
        headerName: 'Number',
        type: 'text',
    },
    {
        field: 'Name',
        headerName: 'Name',
        type: 'text',
        width: 180,
    },
    {
        field: 'Staging Start',
        headerName: 'Start',
        type: 'date',
    },
];

export const InteriorPunchWalkTableColumns = [
    {
        field: 'Number',
        headerName: 'Number',
        type: 'text',
    },
    {
        field: 'Name',
        headerName: 'Name',
        type: 'text',
        width: 180,
    },
    {
        field: 'Interior Punch Start',
        headerName: 'Start',
        type: 'date',
    },
];

export const SelfPerform4WeekLookAheadTableColumns = [
    {
        field: 'Number',
        headerName: 'Number',
        type: 'text',
    },
    {
        field: 'Address',
        headerName: 'Name',
        type: 'text',
        width: 130,
    },
    {
        field: 'Description',
        headerName: 'Description',
        type: 'text',
        width: 300,
    },
    {
        field: 'Status',
        headerName: 'Status',
        type: 'text',
    },
    {
        field: 'Duration',
        headerName: 'Duration',
        type: 'text',
    },
    {
        field: 'Start',
        headerName: 'Start',
        type: 'date',
    },
    {
        field: 'Finish',
        headerName: 'End',
        type: 'date',
    },
];
